export const ADD_PEER = "ADD_PEER";
export const REPLACE_PEER_SUBMISSIONS = "REPLACE_PEER_SUBMISSIONS";
export const DELETE_PEER = "DELETE_PEER";
export const LOAD_PEER = "LOAD_PEER";
export const LOAD_PEER_FAILED = "LOAD_PEER_FAILED";
export const UPDATE_CHOSEN_PEER_EXPOSURE_METRIC =
  "UPDATE_CHOSEN_PEER_EXPOSURE_METRIC";
export const UPDATE_CHOSEN_PEER_EXPOSURE_METRIC_2 =
  "UPDATE_CHOSEN_PEER_EXPOSURE_METRIC_2";
export const UPDATE_PEERS_NOTE = "UPDATE_PEERS_NOTE";
export const UPDATE_SELECTED_PEERS = "UPDATE_SELECTED_PEERS";
export const RECEIVED_SEARCH_RESPONSE = "RECEIVED_SEARCH_RESPONSE";
export const UPDATE_PEER_CHOSEN_EXPOSURE_METRIC =
  "UPDATE_PEER_CHOSEN_EXPOSURE_METRIC";
export const UPDATE_PEERS_INDUSTRY_CLASS = "UPDATE_PEERS_INDUSTRY_CLASS";
